import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { authAPI } from '../lib/api';

export default function GitHubCallback() {
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const code = searchParams.get('code');
    if (!code) {
      navigate('/auth');
      return;
    }

    (async () => {
      try {
        const res = await authAPI.githubAuth({
          code,
          redirect_uri: window.location.origin + '/auth/github/callback',
        });
        login(res.data);
        navigate('/dashboard');
      } catch (err) {
        setError('GitHub authentication failed');
        setTimeout(() => navigate('/auth'), 2000);
      }
    })();
  }, [searchParams, navigate, login]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#020202] flex items-center justify-center">
        <p className="text-red-500 font-mono text-sm">{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#020202] flex items-center justify-center" data-testid="github-callback">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#FF7A3D] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-mono text-[#FF7A3D] text-sm">AUTHENTICATING VIA GITHUB...</p>
      </div>
    </div>
  );
}
